export {
  initAnalytics,
  safeCapture,
  safeIdentify,
  safeRegister,
  safeGroup,
  resetAnalytics,
  getAnalyticsSession,
  isAnalyticsReady,
  sanitizeLinkIdInUrl,
} from "./posthog";
export {
  appendAnalyticsHandoff,
  consumeAnalyticsHandoff,
  wasAnalyticsHandoffConsumed,
} from "./handoff";
export {
  reportAnalyticsSession,
  maybeReportAnalyticsSession,
} from "./report-session";
export { buildDistinctId, normalizeFlow } from "./identity";
export { Events, createEvents, getEvents, setAnalyticsFlow } from "./events";
import { getEvents } from "./events";
import { safeCapture } from "./posthog";

export function trackScreenView(
  screen: string,
  properties?: Record<string, unknown>,
): void {
  safeCapture(getEvents().SCREEN_VIEW(screen), properties);
}
